import React from 'react';
import { m } from 'framer-motion';
import { CreditCardIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { PrimaryButton } from '../ui/PrimaryButton';
import { trackMetaEvent } from '../../utils/metaPixel';
import { CHECKOUT_URL } from '../../utils/checkout';
const trustItems = [{
  icon: CreditCardIcon,
  label: 'Pago único'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}];
const includedItems = ['12 tomos base, de Primaria a Bachillerato.', '6 bonos de apoyo docente.', '12 cuadernos con 30 clases por curso: 360 en total.', 'Fichas del alumnado listas para imprimir.', 'Soluciones, pautas de apoyo y registros docentes en los cuadernos.'];
export function PriceReveal() {
  return <section id="oferta" className="bg-cream-dark py-10 sm:py-14" data-id="element-133" data-mp="1eetzwbjz1otn">
      <div className="mx-auto max-w-xl px-4 text-center sm:px-6" data-id="element-134" data-mp="1ech9da05e64z">
        <p className="font-heading text-lg font-semibold text-navy sm:text-xl" data-id="element-135" data-mp="1j62bne8rxm9z">
          Hoy, el sistema completo cuesta:
        </p>

        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45
      }} className="mt-6 rounded-3xl border border-orange/40 bg-white p-6 shadow-card sm:p-8" data-id="element-136" data-mp="u1x8gwnhzxyb">
          <p className="font-heading text-6xl font-extrabold text-orange-hover sm:text-7xl" data-id="element-137" data-mp="y4bvlsy79jve">19€</p>

          <p className="mt-5 font-heading text-sm font-semibold uppercase tracking-wide text-navy" data-id="element-138" data-mp="1csoj01j81uea">
            Tu acceso incluye
          </p>
          <ul className="mt-3 space-y-2 text-left text-sm leading-relaxed text-ink" data-id="element-139" data-mp="1lvpmrvkm79es">
            {includedItems.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-140" data-mp="1huxdj2bqt4ii">
                <CheckIcon size={16} className="mt-0.5 flex-shrink-0 text-orange-hover" data-id="element-141" data-mp="3nm11f8wzwo8j" />
                <span data-id="element-142" data-mp="3jl8r0cce0dao">{item}</span>
              </li>)}
          </ul>
          <p className="mt-4 text-sm font-medium text-navy" data-id="element-143" data-mp="3jnbthvuq7ywa">Todo organizado por curso, en formato PDF.</p>

          <div className="mt-6" data-id="element-144" data-mp="1rjfvfjyqveha">
            <PrimaryButton fullWidth size="lg" href={CHECKOUT_URL} onClick={() => trackMetaEvent('InitiateCheckout', {
            value: 19,
            currency: 'EUR'
          })} data-id="element-145" data-mp="1rimnifo1uixk">
              Acceso Ahora — 19€
            </PrimaryButton>
          </div>

          <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] text-muted" data-id="element-146" data-mp="25jyzyh4042ep">
            {trustItems.map(item => <span key={item.label} className="flex items-center gap-1" data-id="element-147" data-mp="2ag7b7jf2vbgl">
                <item.icon size={12} data-id="element-148" data-mp="2fablocnjy1mf" /> {item.label}
              </span>)}
          </div>
        </m.div>
      </div>
    </section>;
}